import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { post } from "common/helpers/HTTP";

async function getTypeaheadRequest(
  workspaceId: string,
  accountId: string,
  type: string,
  query: string,
): Promise<{ text: string; id: string }[]> {
  const { options } = await post(
    `workspaces/${workspaceId}/accounts/${accountId}/sales-navigator/typeahead?count=100`,
    {
      type,
      query: query || undefined,
    },
  );
  return options;
}

export default function useNavigatorTypeahead({
  accountId,
  type,
  query,
}: {
  accountId: string;
  type: string;
  query?: string;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { leadListSourcesKeys } = getQueryKeys(workspaceId);

  const { data: typeaheadOptions, isLoading: isLoadingTypeaheadOptions } =
    useQuery({
      queryKey: leadListSourcesKeys.navigatorTypeahead(accountId, type, query),
      queryFn: () => getTypeaheadRequest(workspaceId, accountId, type, query),
      enabled: !!accountId,
    });
  return { typeaheadOptions, isLoadingTypeaheadOptions };
}
